<template>
  <v-menu
    v-model="menuDate"
    :close-on-content-click="false"
    :nudge-right="40"
    :label="label"
    transition="scale-transition"
    offset-y
    style="position: relative"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <!-- style="left: 0px; right: auto; position: absolute;" -->
      <v-text-field
        v-model="localDateFormatted"
        :label="label"
        prepend-icon="far fa-calendar-alt"
        v-on="on"
        :disabled="dateDisabled"
        @blur="localDate = parseDate(localDateFormatted)"
      >
        <v-tooltip slot="append" top :disabled="dateDisabled">
          <template v-slot:activator="{ on }">
            <v-btn icon small @click="selectToday" v-on="on">
              <v-icon small>
                mdi-calendar-today
              </v-icon>
            </v-btn>
          </template>
          <span>Danes</span>
        </v-tooltip>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="localDate"
      :disabled="dateDisabled"
      locale="sl-SI"
      first-day-of-week="1"

      @input="menuDate = false">
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    date: {
      type: String
    },
    label: {
      default: 'Datum',
      type: String
    },
    dateDisabled: {
      default: false,
      type: Boolean,
    }
  },
  data () {
    return {
      menuDate: false,
      localDateFormatted: this.formatDate(this.date),
      localDate: this.date
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    selectToday () {
      this.localDate = moment().format('YYYY-MM-DD')
    },
    setDate (date) {
      this.localDate = date
    }
  },
  watch: {
    localDate (date) {
      this.localDateFormatted = this.formatDate(this.localDate)
      this.$emit('change', { date: this.localDate })
    }
  }
}
</script>
